import { on } from 'delegated-events';
import scrollTo from '../common/scrollTo';

const $clearFilters = document.querySelector('.job-postings-clear');

const fn = {
    init: () => {
        fn.bindEvents();
        // fn.filterPostings();
        if (window.location.hash) {
            fn.getHash();
        }
    },

    getHash: () => {
        if (window.location.href) {
            document
                .querySelector(window.location.hash)
                .classList.add('is-active');
            document
                .querySelector(window.location.hash)
                .childNodes[1].childNodes[3].childNodes[3].setAttribute(
                    'aria-expanded',
                    'true'
                );
            document.querySelector(
                window.location.hash
            ).childNodes[1].childNodes[3].childNodes[3].childNodes[0].nodeValue =
                'Hide Details';
            document.querySelector(
                window.location.hash
            ).childNodes[3].style.display = 'block';
            // scrollTo(document.querySelector(window.location.hash), 20);
        }
    },

    bindEvents: () => {
        on('click', '.job-postings-filter', e => {
            const $active = document.querySelector(
                '.job-postings-filter.is-active'
            );

            if ($active) {
                $active.classList.remove('is-active');
            }

            e.target.classList.add('is-active');
            fn.filterPostings();
        });

        on('click', '.job-postings-clear button', () => {
            const $active = document.querySelector(
                '.job-postings-filter.is-active'
            );

            if ($active) {
                $active.classList.remove('is-active');
            }

            $clearFilters.style.display = 'none';

            scrollTo(document.body);

            fn.filterPostings();
        });
    },

    filterPostings: () => {
        const $activeFilter = document.querySelector(
            '.job-postings-filter.is-active'
        );

        if ($activeFilter) {
            const type = $activeFilter.dataset.type;

            Array.from(document.querySelectorAll('.job-posting')).forEach(
                el => (el.style.display = 'none')
            );

            Array.from(
                document.querySelectorAll(`.job-posting[data-type="${type}"]`)
            ).forEach(el => (el.style.display = 'block'));

            if ($clearFilters) {
                $clearFilters.style.display = 'block';
            }
        } else {
            Array.from(document.querySelectorAll('.job-posting')).forEach(
                el => (el.style.display = 'block')
            );
        }
    },
};

export default {
    can: () => document.body.classList.contains('pagetype-careerspage'),
    run: fn.init,
};
